import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBookmarkPlus"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.2704L12 17.8566L20 22.2704V2H4ZM12.75 6V9.25H16V10.75H12.75V14H11.25V10.75H8V9.25H11.25V6H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkPlus;
